var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-pond',{ref:"pond",attrs:{"name":"test","label-idle":"Drag & Drop or Browse","allow-multiple":true},on:{"processfile":_vm.fileUploaded,"removefile":_vm.fileRemoved}})}
var staticRenderFns = []

export { render, staticRenderFns }